var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "b-tabs",
        {
          attrs: { "content-class": "mt-3", align: "left" },
          model: {
            value: _vm.tabIndex,
            callback: function($$v) {
              _vm.tabIndex = $$v
            },
            expression: "tabIndex"
          }
        },
        [
          _vm.showSelectProfile
            ? _c(
                "b-tab",
                {
                  attrs: {
                    "title-link-class": "h3 tab",
                    title: "Select a Profile"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "py-5 d-flex flex-column",
                      staticStyle: { gap: "24px" }
                    },
                    [
                      _vm.infoContent
                        ? _c(
                            "b-alert",
                            { attrs: { variant: "info", show: "" } },
                            [
                              _c("b-icon-exclamation-circle", {
                                staticClass: "mr-3"
                              }),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.infoContent) +
                                  "\n                "
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-alert",
                        { attrs: { variant: "info", show: "" } },
                        [
                          _c("b-icon-exclamation-circle", {
                            staticClass: "mr-3"
                          }),
                          _vm._v(
                            "\n                    The below profiles are associated with your One Healthcare ID.\n                    If you do not see the profile you are looking for, select the\n                    "
                          ),
                          _c("span", { staticClass: "font-weight-bold" }, [
                            _vm._v("Link a Profile")
                          ]),
                          _vm._v(" tab.\n                ")
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("profile-list", {
                    staticClass: "w-50",
                    attrs: { profiles: _vm.profilesList }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-tab",
            {
              attrs: { "title-link-class": "h3 tab", title: "Link a Profile" }
            },
            [
              _c(
                "b-alert",
                { attrs: { variant: "info", show: "" } },
                [
                  _c("b-icon-exclamation-circle", { staticClass: "mr-3" }),
                  _vm._v(
                    "\n                If you are already a registered user of myVACCN.com, please enter your username and password.\n                If not, please select Register now.\n            "
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("link-profile", { attrs: { "set-tab": _vm.setTab } })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07dc77ce", { render: render, staticRenderFns: staticRenderFns })
  }
}